import React from "react";

const FacialInUptownWhat = () => {
  return (
    <div className="hairSalonInUptownHead">
      <h3>What to Expect from Your Facial at SCENT</h3>
      <p>
        When you book a facial at SCENT, you can expect a premium experience
        from start to finish. From the moment you walk into our{" "}
        <a href="https://scentlifestyle.com/nail-salon-in-uptown-whitefield">
          nail salon in Uptown Whitefield
        </a>
        , you’ll be greeted by our friendly staff and guided through a
        personalized consultation. Our aestheticians will assess your skin and
        recommend the most suitable facial treatment based on your skin type and
        concerns.
      </p>
      <p>
        During the facial, you can relax in our serene environment while our
        skincare experts work their magic. We use a combination of advanced
        products and techniques, including exfoliation, extractions, massage,
        and masks, to ensure your skin looks and feels its best.
      </p>
    </div>
  );
};

export default FacialInUptownWhat;
